<div id="doctors-list" class="flex flex-col gap-3">
  <div>
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
  </div>
  <form [formGroup]="productForm">
    <h1 class="text-center m-4">Add New Product</h1>
    <div class="body flex flex-col gap-3">
      <input id="name" type="text" formControlName="name" placeholder="Product Name">
      <div class="flex flex-row gap-6">
        <!--        <input id="category" type="text" formControlName="category" placeholder="Product category">-->
        <mat-select placeholder="Category" formControlName="category_id">
          @for (category of categories; track category) {
            <mat-option [value]="category.id">{{ category.name }}</mat-option>
          }
        </mat-select>
        <mat-select placeholder="Budget" formControlName="budget">
          @for (category of budgetOptions; track category) {
            <mat-option [value]="category">{{ category }}</mat-option>
          }
        </mat-select>

        <!--        <nz-select-->
        <!--          nzMode="multiple"-->
        <!--          nzPlaceHolder="Application Time"-->
        <!--          formControlName="application_time"-->
        <!--        >-->
        <!--          @for (item of applicationTimes; track item) {-->
        <!--            <nz-option [nzLabel]="item.label" [nzValue]="item.value"></nz-option>-->
        <!--          }-->
        <!--        </nz-select>-->
        <mat-select placeholder="Application Time" multiple formControlName="application_time">
          <mat-select-trigger>
            <mat-chip-set #chipGrid aria-label="Enter time">
              @for (appTime of productForm.controls['application_time'].value; track appTime) {
                <mat-chip-row (removed)="removeAppTime(appTime)">
                  {{ appTime }}
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-set>
          </mat-select-trigger>

          @for (app of applicationTimes; track app) {
            <mat-option [value]="app">{{ app }}</mat-option>
          }
        </mat-select>
        <!--        <input id="time" type="text" formControlName="application_time" placeholder="Application time">-->
      </div>
      <!--      <input id="image" type="text" formControlName="image" placeholder="Image Url">-->
      <!--      <div (click)="uploadFile.click()">-->
      <!--        <button mat-raised-button color="primary">Choose File</button>-->
      <!--        <input #uploadFile formControlName="image" type='file' style="display:none" accept="image/*"/>-->
      <!--      </div>-->

      <mat-select formControlName="ingredients" multiple placeholder="Product tags">
        <mat-select-trigger>
          <mat-chip-set #chipGrid aria-label="Enter fruits">
            @for (topping of productForm.controls['ingredients'].value; track topping) {
              <mat-chip-row (removed)="remove(topping)">
                {{ topping }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-set>
        </mat-select-trigger>


        @for (topping of taglist; track topping) {
          <mat-option [value]="topping">{{ topping }}</mat-option>
        }
      </mat-select>
      <textarea formControlName="description" matInput placeholder="Description"></textarea>

      <app-file-upload (fileSelected)="onFileSelected($event)"></app-file-upload>
      <button mat-flat-button (click)="save()">
        Save
      </button>
    </div>
  </form>
</div>
